<div class="dx-card wide-card">
    <h4 class="content-block ap-green">O2 ASU Awards by Competitor</h4>

    <div class="content-block">
        <o2-report-filters (viewReport)="getO2PortalAwardsByCompetitor($event)"></o2-report-filters>
        <dx-responsive-box singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-item>
                <dxi-location [row]="0" [col]="0" [colspan]="2"></dxi-location>
                <h4 class="ap-green">Historical Awards: {{fromDate}} - {{toDate}}</h4>
                <div class="btndiv">
                    <dx-button icon="export" text="Export Charts" type="default" [width]="160"
                        (onClick)="exportCharts()">
                    </dx-button>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="1" [col]="0" [colspan]="2"></dxi-location>
                <h4 class="content-block" style="text-align: center;">Volume Analysis by Competitor: All Business Model
                </h4>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="2" [col]="0"></dxi-location>
                <dx-pie-chart [resolveLabelOverlapping]="resolveOverlappingTypes[0]" #dxAllBusinessPieChart
                    id="dxAllBusinessPieChart" palette="soft" [dataSource]="allBusinessPieChartData">
                    <dxi-series argumentField="topCompetitors" valueField="cumulativePercent">
                        <dxo-label [customizeText]="customizeAllBusinessLabel" [visible]="true">
                            <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                        </dxo-label>
                    </dxi-series>
                    <dxo-size [width]="500"></dxo-size>
                </dx-pie-chart>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="2" [col]="1"></dxi-location>
                <div class="dx-field">
                    <dx-chart [customizePoint]="customizeAllBusinessPoint" class="width100" #dxAllBusinessBarChart
                        id="dxAllBusinessBarChart" [dataSource]="allBusinessBarChartData">
                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-common-series-settings argumentField="awardYear" valueField="totalOxygen"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Total O2 (mtpd)"></dxo-title>
                        </dxi-value-axis>
                        <dxo-legend verticalAlignment="top" horizontalAlignment="center" [visible]="false">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-argument-axis [allowDecimals]="false">
                        </dxo-argument-axis>
                        <dxo-series-template nameField="topCompetitors"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="3" [col]="0"></dxi-location>
                <label class="label-text">{{totalAllBusinessGaseousOxygenText}}</label>
            </dxi-item>
            <hr />
            <dxi-item>
                <dxi-location [row]="4" [col]="0" [colspan]="2"></dxi-location>
                <hr />
                <h4 class="content-block" style="text-align: center;">Volume Analysis By Competitor: SOG Business Model
                </h4>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="5" [col]="0"></dxi-location>
                <dx-pie-chart [resolveLabelOverlapping]="resolveOverlappingTypes[0]" #dxSOGBusinessPieChart
                    id="dxSOGBusinessPieChart" palette="soft" [dataSource]="sOGBusinessPieChartData">
                    <dxi-series argumentField="topCompetitors" valueField="cumulativePercent">
                        <dxo-label [customizeText]="customizeSOGBusinessLabel" [visible]="true">
                            <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                        </dxo-label>
                    </dxi-series>
                    <dxo-size [width]="500"></dxo-size>
                </dx-pie-chart>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="5" [col]="1"></dxi-location>
                <div class="dx-field">
                    <dx-chart [customizePoint]="customizeSOGBusinessPoint" class="width100" #dxSOGBusinessBarChart
                        id="dxSOGBusinessBarChart" [dataSource]="sOGBusinessBarChartData">
                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-common-series-settings argumentField="awardYear" valueField="totalOxygen"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Total O2 (mtpd)"></dxo-title>
                        </dxi-value-axis>
                        <dxo-legend verticalAlignment="top" horizontalAlignment="center" [visible]="false">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-argument-axis [allowDecimals]="false">
                        </dxo-argument-axis>
                        <dxo-series-template nameField="topCompetitors"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="6" [col]="0"></dxi-location>
                <label class="label-text">{{totalSOGBusinessGaseousOxygenText}}</label>
            </dxi-item>

            <hr />
            <dxi-item>
                <dxi-location [row]="7" [col]="0" [colspan]="2"></dxi-location>
                <hr />
                <h4 style="text-align: center;">Volume Analysis By Competitor: SOE Business Model
                </h4>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="8" [col]="0"></dxi-location>
                <dx-pie-chart [resolveLabelOverlapping]="resolveOverlappingTypes[0]" #dxSOEBusinessPieChart
                    id="dxSOGBusinessPieChart" palette="soft" [dataSource]="sOEBusinessPieChartData">
                    <dxi-series argumentField="topCompetitors" valueField="cumulativePercent">
                        <dxo-label [customizeText]="customizeSOEBusinessLabel" [visible]="true">
                            <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                        </dxo-label>
                    </dxi-series>
                    <dxo-size [width]="500"></dxo-size>
                </dx-pie-chart>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="8" [col]="1"></dxi-location>
                <div class="dx-field">
                    <dx-chart [customizePoint]="customizeSOEBusinessPoint" class="width100" #dxSOEBusinessBarChart
                        id="dxSOEBusinessBarChart" [dataSource]="sOEBusinessBarChartData">
                        <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                        <dxo-common-series-settings argumentField="awardYear" valueField="totalOxygen"
                            type="stackedBar">
                        </dxo-common-series-settings>
                        <dxi-value-axis position="left">
                            <dxo-title text="Total O2 (mtpd)"></dxo-title>
                        </dxi-value-axis>
                        <dxo-legend verticalAlignment="top" horizontalAlignment="center" [visible]="false">
                        </dxo-legend>
                        <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeTooltip">
                            <dxo-format type="thousands" [precision]="1">
                            </dxo-format>
                        </dxo-tooltip>
                        <dxo-argument-axis [allowDecimals]="false">
                        </dxo-argument-axis>
                        <dxo-series-template nameField="topCompetitors"></dxo-series-template>
                        <dxo-scroll-bar [visible]="false"></dxo-scroll-bar>
                    </dx-chart>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="9" [col]="0"></dxi-location>
                <label class="label-text">{{totalSOEBusinessGaseousOxygenText}}</label>
            </dxi-item>
        </dx-responsive-box>
        <hr />
        <div class="btndiv">
            <dx-button icon="export" text="Export Grids" type="default" [width]="145" (onClick)="exportExcel($event)">
            </dx-button>
        </div>
        <div class="marginT15">
            <h4 class="lblmargin ap-green">Volume Analysis By Region & Competitor</h4>
            <dx-pivot-grid #VolumeAnalysisByRegionAndCompetitor id="VolumeAnalysisByRegionAndCompetitor"
                [allowSortingBySummary]="true" [allowFiltering]="false" (onCellPrepared)="onCellPrepared($event)"
                [showBorders]="true" [showColumnGrandTotals]="true" [showRowGrandTotals]="true" [showRowTotals]="true"
                [showColumnTotals]="false" [dataSource]="pivotGridRegionAndCompititorDataSource">
                <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
            </dx-pivot-grid>
        </div>
        <div class="marginT15">
            <h4 class="lblmargin ap-green">Volume Analysis By Process & Competitor</h4>
            <dx-pivot-grid class="grdmargin" #VolumeAnalysisByProcessAndCompetitor id="VolumeAnalysisByProcessAndCompetitor"
                [allowSortingBySummary]="true" [allowFiltering]="false" (onCellPrepared)="onCellPrepared($event)"
                [showBorders]="true" [showColumnGrandTotals]="true" [showRowGrandTotals]="true" [showRowTotals]="true"
                [showColumnTotals]="false" [dataSource]="pivotGridProcessAndCompititorDataSource">
                <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
            </dx-pivot-grid>
        </div>
        <div class="marginT15">
            <h4 class="lblmargin ap-green">Volume Analysis By Application & Competitor</h4>
            <dx-pivot-grid class="grdmargin" #VolumeAnalysisByApplicationAndCompetitor id="VolumeAnalysisByApplicationAndCompetitor"
                [allowSortingBySummary]="true" [allowFiltering]="false" (onCellPrepared)="onCellPrepared($event)"
                [showBorders]="true" [showColumnGrandTotals]="true" [showRowGrandTotals]="true" [showRowTotals]="true"
                [showColumnTotals]="false" [dataSource]="pivotGridApplicationAndCompititorDataSource">
                <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
            </dx-pivot-grid>
        </div>
        <div class="marginT15">
            <h4 class="lblmargin ap-green">Volume Analysis By ASU Nominal Capacity & Competitor</h4>
            <dx-pivot-grid class="grdmargin" #VolumeAnalysisByASUNominalCapacityAndCompetitor
                id="VolumeAnalysisByASUNominalCapacityAndCompetitor" [allowSortingBySummary]="true"
                [allowFiltering]="false" (onCellPrepared)="onCellPrepared($event)" [showBorders]="true"
                [showColumnGrandTotals]="true" [showRowGrandTotals]="true" [showRowTotals]="true"
                [showColumnTotals]="false" [dataSource]="pivotGridASUNominalCapacityAndCompititorDataSource">
                <dxo-field-chooser [enabled]="false" [height]="400"></dxo-field-chooser>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
            </dx-pivot-grid>
        </div>
    </div>
</div>